import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  addCategory,
  removeCategory,
} from '../../../../supplier-portal/catalogue/src/lib/containers/add-new-product/+state/add-product.actions';
import { Store } from '@ngrx/store';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from 'rxjs/operators';
import { ProductsService } from '@boma/supplier-portal/shared/services';

@Component({
  selector: 'boma-category-selector',
  templateUrl: './boma-category-selector.component.html',
  styleUrls: ['./boma-category-selector.component.scss'],
})
export class BomaCategorySelectorComponent implements OnInit {
  @Input() multipleCategories = false;
  @Input() disabled = false;
  @Input() categoryIds: { id: string; name: string }[] = [];
  @Input() placeholder = 'Start typing to find a category';
  @Output() updateCategories = new EventEmitter();

  categorySearchSubject = new Subject<string>();
  categorySearchResults$: Observable<{ id: string; name: string }[]>;

  selectedCategories: { name: string; id: string }[];

  constructor(
    public store: Store,
    private productService: ProductsService
  ) {}

  ngOnInit(): void {
    this.categorySearchResults$ = this.categorySearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((searchTerm) =>
        this.productService.searchCategories(searchTerm)
      ),
      map((x) =>
        // TODO This use to be a paginated result see admin
        x.map((c) => ({
          id: c.id,
          name: c.name,
        }))
      )
    );
  }

  searchCategory(event) {
    this.categorySearchSubject.next(event.query);
  }

  onAddCategory(value) {
    //This works due to storing these values to state... will have to update when not using state.
    this.store.dispatch(addCategory({ categoryId: value.id, category: value }));
    this.updateCategories.emit(this.selectedCategories); // place in handle of category
  }

  onRemoveCategory(value) {
    this.store.dispatch(
      removeCategory({ categoryId: value.id, category: value })
    );
    this.updateCategories.emit(this.selectedCategories);
  }
}
